/**
 * True when `name` matches another item's name, ignoring case and
 * leading/trailing whitespace. The item whose id equals `excludeId`
 * (the one being edited) is never counted. An empty name is never a duplicate.
 */
export const isDuplicateName = (
  name: string,
  existing: { id?: string | null; name?: string | null }[],
  excludeId: string | null = null
): boolean => {
  const wanted = name.trim().toLowerCase();
  if (!wanted) return false;
  return existing.some(
    (item) =>
      item.id !== excludeId &&
      String(item.name ?? "").trim().toLowerCase() === wanted
  );
};
